import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { CommunicationService } from 'src/app/services/communication';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { Logger } from 'projects/common/src/app/classes';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportHourmeterFuelService extends Logger {
  private baseUrl: string;
  constructor(
    private communicationService: CommunicationService,
    private cacheService: CacheService,
    private http: HttpClient,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * get data report hourmeter and fuel
   */
  public GetReportHourmeterFuel(selectedFilters: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.baseUrl}/Report/GetHourmeterAndFuelReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * get data excel report hourmeter and fuel
   */
  public GetReportHourmeterFuelExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetHourmeterAndFuelReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * set Params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: String(selectedFilters.shiftId),
      machineTypeList: selectedFilters.machineTypeId,
      machineList: selectedFilters.machineId,
      companyId,
    };
  }
}
